import React from 'react';

import { useGlobalStore } from '@client/store/globalStore/context/globalContext';
import { Login as LoginForm } from '@ledium/login';

const Login = () => {
    const { globalActions } = useGlobalStore();

    function onSubmit(username: string, password: string) {
        globalActions.users.callUserLogin({ username, password });
    }

    return <LoginForm onSubmit={onSubmit} />;
};

export default React.memo(Login);
